import { Component } from '@angular/core';

@Component({
  selector: 'era-panel-footer',
  templateUrl: './panel-footer.component.html',
  styleUrls: ['./panel-footer.component.scss'],
})
export class PanelFooterComponent {}
